<template>
  <div>
    <Nav></Nav>
    <b-container fluid="xl">
      <b-row class="mt-3"><b-col><h1>Marketing → Notificaciones</h1></b-col></b-row>

      <b-card class="mb-3" title="Parámetros globales">
        <b-row>
          <b-col md="3"><b-form-group label="Silencio desde"><b-form-input v-model="cfg.from" placeholder="22:00"></b-form-input></b-form-group></b-col>
          <b-col md="3"><b-form-group label="Silencio hasta"><b-form-input v-model="cfg.to" placeholder="09:00"></b-form-input></b-form-group></b-col>
          <b-col md="3"><b-form-group label="Zona horaria"><b-form-input v-model="cfg.timezone"></b-form-input></b-form-group></b-col>
          <b-col md="3"><b-form-group label="Tope diario por cliente"><b-form-input type="number" v-model.number="cfg.daily_cap"></b-form-input></b-form-group></b-col>
        </b-row>
        <b-button variant="primary" @click="saveConfig">Guardar</b-button>
      </b-card>

      <b-card class="mb-3" title="Reglas">
        <b-button variant="primary" size="sm" @click="openNew">Nueva regla</b-button>
        <b-table small striped responsive :items="rules" :fields="ruleFields" :busy="loading" class="mt-2">
          <template #cell(is_marketing)="data"><b-badge :variant="data.item.is_marketing ? 'warning':'secondary'">{{ data.item.is_marketing ? 'marketing':'transaccional' }}</b-badge></template>
          <template #cell(active)="data"><b-badge :variant="data.item.active ? 'success':'secondary'">{{ data.item.active ? 'activa':'inactiva' }}</b-badge></template>
          <template #cell(buttons)="data">
            <b-button size="sm" variant="warning" @click="openEdit(data.item)">Editar</b-button>
            <b-button size="sm" variant="info" @click="openTest(data.item)">Probar</b-button>
            <b-button size="sm" variant="outline-danger" @click="del(data.item)">Eliminar</b-button>
          </template>
        </b-table>
      </b-card>

      <b-card title="Log de notificaciones">
        <b-form-select v-model="logStatus" :options="logStatusOptions" @change="loadLog" style="max-width:200px;"></b-form-select>
        <b-table class="mt-2" small striped responsive :items="log" :fields="logFields">
          <template #cell(buttons)="data">
            <b-button size="sm" variant="outline-info" v-if="data.item.status==='failed'" @click="retry(data.item)">Reintentar</b-button>
          </template>
        </b-table>
      </b-card>
    </b-container>

    <b-modal v-model="showRule" :title="editing.id ? 'Editar regla':'Nueva regla'" size="lg" @ok="saveRule" ok-title="Guardar">
      <b-form-group label="Código"><b-form-input v-model="editing.code"></b-form-input></b-form-group>
      <b-form-group label="Evento disparador"><b-form-select v-model="editing.trigger_event" :options="eventOptions"></b-form-select></b-form-group>
      <b-form-group label="Condición (JSON)"><b-form-input v-model="editing.condition_json" placeholder='{"days_without_purchase":5}'></b-form-input></b-form-group>
      <b-row>
        <b-col><b-form-group label="Retraso (min)"><b-form-input type="number" v-model.number="editing.delay_minutes"></b-form-input></b-form-group></b-col>
        <b-col><b-form-group label="Canal"><b-form-select v-model="editing.channel" :options="['push','email']"></b-form-select></b-form-group></b-col>
        <b-col><b-form-group label="Marketing"><b-form-checkbox v-model="editing.is_marketing" switch></b-form-checkbox></b-form-group></b-col>
        <b-col><b-form-group label="Activa"><b-form-checkbox v-model="editing.active" switch></b-form-checkbox></b-form-group></b-col>
      </b-row>
      <b-form-group label="Título"><b-form-input v-model="editing.title_tpl"></b-form-input></b-form-group>
      <b-form-group :label="bodyHelpLabel">
        <b-form-textarea v-model="editing.body_tpl" rows="2"></b-form-textarea>
      </b-form-group>
      <b-form-group label="Deep link"><b-form-input v-model="editing.deep_link" placeholder="app://home"></b-form-input></b-form-group>
      <b-row>
        <b-col><b-form-group label="Máx por cliente"><b-form-input type="number" v-model.number="editing.max_per_customer"></b-form-input></b-form-group></b-col>
        <b-col><b-form-group label="Cooldown (horas)"><b-form-input type="number" v-model.number="editing.cooldown_hours"></b-form-input></b-form-group></b-col>
      </b-row>
      <hr />
      <p class="text-muted mb-0">Vista previa: <strong>{{ preview.title }}</strong> — {{ preview.body }}</p>
    </b-modal>

    <b-modal v-model="showTest" title="Enviar prueba" @ok="doTest" ok-title="Enviar">
      <b-form-group label="Cliente (id)"><b-form-input type="number" v-model.number="testCustomerId"></b-form-input></b-form-group>
    </b-modal>
  </div>
</template>

<script>
import Nav from "../../components/Nav.vue";
import marketingService from "../../services/marketingService";
import featuresService from "../../services/featuresService";

export default {
  name: "notificaciones",
  components: { Nav },
  data() {
    return {
      rules: [],
      loading: false,
      log: [],
      logStatus: "",
      cfg: { from: "22:00", to: "09:00", timezone: "America/Mexico_City", daily_cap: 2 },
      rawConfig: {},
      showRule: false,
      editing: {},
      showTest: false,
      testRuleId: null,
      testCustomerId: null,
      bodyHelpLabel: "Cuerpo (usa {{name}}, {{points}}, {{tier}}, {{next_tier}}, {{points_to_next}}, {{expires}})",
      eventOptions: [
        "customer.registered", "customer.no_first_purchase", "customer.inactive", "customer.birthday",
        "customer.reinstalled", "tier.upgraded", "tier.near", "loyalty.points_earned", "loyalty.points_expiring",
        "benefit.expiring", "referral.rewarded", "order.status", "survey.invite",
      ],
      ruleFields: [
        { key: "code", label: "Código" },
        { key: "trigger_event", label: "Evento" },
        { key: "is_marketing", label: "Tipo" },
        { key: "active", label: "Estado" },
        { key: "buttons", label: "" },
      ],
      logStatusOptions: [
        { value: "", text: "Todos" }, { value: "sent", text: "Enviados" }, { value: "failed", text: "Fallidos" },
        { value: "skipped", text: "Omitidos" }, { value: "queued", text: "En cola" },
      ],
      logFields: [
        { key: "created_at", label: "Fecha" },
        { key: "customer_id", label: "Cliente" },
        { key: "rule_id", label: "Regla" },
        { key: "status", label: "Estado" },
        { key: "error", label: "Error" },
        { key: "buttons", label: "" },
      ],
    };
  },
  computed: {
    preview() {
      const vars = { name: "Juan", points: "165", tier: "Plata", next_tier: "Oro", points_to_next: "500", expires: "2026-12-31", benefit: "Envío gratis" };
      const render = (t) => (t || "").replace(/\{\{(\w+)\}\}/g, (m, k) => vars[k] || m);
      return { title: render(this.editing.title_tpl), body: render(this.editing.body_tpl) };
    },
  },
  mounted() {
    this.load();
    this.loadLog();
    this.loadConfig();
  },
  methods: {
    load() {
      this.loading = true;
      marketingService.listRules()
        .then((res) => { this.rules = res.data || []; })
        .catch((err) => this.makeToast("Error", this.errMsg(err), "danger"))
        .finally(() => (this.loading = false));
    },
    loadLog() {
      marketingService.notificationLog({ status: this.logStatus, limit: 100 })
        .then((res) => { this.log = res.data || []; }).catch(() => {});
    },
    loadConfig() {
      featuresService.getAll().then((res) => {
        const f = res.data && res.data.features && res.data.features["notifications.lifecycle"];
        if (f && f.config) {
          this.rawConfig = f.config;
          const qh = f.config.quiet_hours || {};
          this.cfg.from = qh.from || "22:00";
          this.cfg.to = qh.to || "09:00";
          this.cfg.timezone = f.config.timezone || "America/Mexico_City";
          this.cfg.daily_cap = f.config.daily_cap_per_customer != null ? f.config.daily_cap_per_customer : 2;
        }
      }).catch(() => {});
    },
    saveConfig() {
      const config = { ...this.rawConfig, quiet_hours: { from: this.cfg.from, to: this.cfg.to }, timezone: this.cfg.timezone, daily_cap_per_customer: this.cfg.daily_cap };
      featuresService.update("notifications.lifecycle", { enabled: true, config })
        .then(() => this.makeToast("Guardado", "Parámetros actualizados", "success"))
        .catch((err) => this.makeToast("Error", this.errMsg(err), "danger"));
    },
    openNew() {
      this.editing = { code: "", trigger_event: "customer.registered", condition_json: "", delay_minutes: 0, channel: "push", is_marketing: false, active: true, title_tpl: "", body_tpl: "", deep_link: "", max_per_customer: null, cooldown_hours: null };
      this.showRule = true;
    },
    openEdit(r) {
      this.editing = { ...r, condition_json: this.strOf(r.condition_json), deep_link: this.strOf(r.deep_link), max_per_customer: this.numOf(r.max_per_customer), cooldown_hours: this.numOf(r.cooldown_hours) };
      this.showRule = true;
    },
    strOf(v) { if (v && v.String !== undefined) return v.Valid ? v.String : ""; return v || ""; },
    numOf(v) { if (v && v.Int64 !== undefined) return v.Valid ? v.Int64 : null; return v; },
    saveRule(evt) {
      evt.preventDefault();
      const payload = { ...this.editing };
      const req = this.editing.id ? marketingService.updateRule(this.editing.id, payload) : marketingService.createRule(payload);
      req.then(() => { this.showRule = false; this.load(); this.makeToast("Guardado", "Regla guardada", "success"); })
        .catch((err) => this.makeToast("Error", this.errMsg(err), "danger"));
    },
    del(r) {
      marketingService.deleteRule(r.id).then(() => { this.load(); this.makeToast("Listo", "Regla eliminada", "success"); })
        .catch((err) => this.makeToast("Error", this.errMsg(err), "danger"));
    },
    openTest(r) { this.testRuleId = r.id; this.testCustomerId = null; this.showTest = true; },
    doTest(evt) {
      evt.preventDefault();
      marketingService.testNotification(this.testRuleId, this.testCustomerId)
        .then(() => { this.showTest = false; this.loadLog(); this.makeToast("Listo", "Prueba enviada", "success"); })
        .catch((err) => this.makeToast("Error", this.errMsg(err), "danger"));
    },
    retry(l) {
      marketingService.testNotification(l.rule_id, l.customer_id)
        .then(() => { this.loadLog(); this.makeToast("Listo", "Reintentado", "success"); })
        .catch((err) => this.makeToast("Error", this.errMsg(err), "danger"));
    },
    errMsg(err) {
      if (err && err.response && err.response.data) {
        return typeof err.response.data === "string" ? err.response.data : (err.response.data.error || JSON.stringify(err.response.data));
      }
      return err && err.message ? err.message : "Error desconocido";
    },
    makeToast(title, content, variant) {
      this.$bvToast.toast(content, { title, variant, autoHideDelay: 5000, appendToast: true });
    },
  },
};
</script>
